export default __webpack_public_path__ + "static/media/instagram.e80384e4.svg";